import AccountManager from './../AccountManager.js';
export default class BaseTrezorTransport {
    accountManager = null;
    async connect() {
        return Promise.resolve();
    }
    async getAccountManager() {
        if (!this.accountManager) {
            this.accountManager = new AccountManager();
        }
        return this.accountManager;
    }
}
